/**
 * NotificationBuilder to build ErrorNotification
 * @public
 */
export class NotificationBuilder {
    /**
     * Add position to notification
     * @public
     * @param position - {@link ErrorNotificationPosition}
     * @returns
     */
    withPosition(position) {
        this.position = position;
        return this;
    }
    /**
     * Add auto close to notification
     * @public
     * @param autoClose - boolean
     * @returns
     */
    withAutoClose(autoClose) {
        this.autoClose = autoClose;
        return this;
    }
    /**
     * Add close timeout to notification
     * @public
     * @param closeTimeout - number
     * @returns
     */
    withCloseTimeout(closeTimeout) {
        this.closeTimeout = closeTimeout;
        return this;
    }
    /**
     * Add type to notification, if the type is anything other than 'warning' or 'success' do not add it
     * @public
     * @param type - {@link ErrorNotificationType}
     * @returns
     */
    withType(type) {
        this.type = type;
        return this;
    }
    /**
     * Build notification
     * @returns ErrorNotification
     */
    build() {
        let notification = {};
        if (this.position) {
            notification = Object.assign({ position: this.position }, notification);
        }
        if (this.autoClose) {
            notification = Object.assign({ autoClose: this.autoClose }, notification);
        }
        if (this.closeTimeout) {
            notification = Object.assign({ closeTimeout: this.closeTimeout }, notification);
        }
        if (this.type) {
            notification = Object.assign({ type: this.type }, notification);
        }
        return notification;
    }
}
/**
 * Get notification builder instance
 * @public
 */
export const getNotificationBuilder = () => new NotificationBuilder();
